import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Popover from "@material-ui/core/Popover";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import {
  Box,
  Card,
  CardActionArea,
  Collapse,
  Grid,
  Icon,
  IconButton,
  Paper,
} from "@material-ui/core";
import ExpandMoreRoundedIcon from "@material-ui/icons/ExpandMoreRounded";
import CloseRoundedIcon from "@material-ui/icons/CloseRounded";
import greenSuccessIcon from "../../../assets/images/greenSuccessIcon.png";
import ArrowBackRoundedIcon from "@material-ui/icons/ArrowBackRounded";
import { useWindowDimensions } from "../windowsize";

const useStyles = makeStyles((theme) => ({
  rootroot: {
    position: "relative",
  },
  root: {
    transform: "translate(-50px, -100px) !important",
    boxShadow: theme.shadows[20],
    width: "460px",
    height: "550px",
    position: "relative",
    padding: "30px",
    paddingTop: "123px",
    [theme.breakpoints.down('md')]: {
      transform: "translate(0px, -100px) !important",
    }
  },
  root2: {
    transform: "translate(-50px, -100px) !important",
    boxShadow: theme.shadows[20],
    width: "460px",
    height: "550px",
    position: "relative",
    paddingTop: "80px",
    [theme.breakpoints.down('md')]: {
      transform: "translate(50px, -100px) !important",
    }
  },
  header: {
    padding: "20px !important",
    backgroundColor: "#644b9f",
    position: "absolute",
    width: "100%",
    top: 0,
    left: 0,
  },
  ty: {
    fontFamily: "Montserrat",
    fontSize: "26px",
    fontWeight: "bold",
    color: "white",
  },
  ty2: {
    fontFamily: "Montserrat",
    fontSize: "16px",
    color: "white",
  },
  card: {
    height: "100px",
    "&:hover": {
      backgroundColor: "#b499d7",
    },
  },
  cardActionArea: {
    height: "100px",
    borderBottom: "5px solid #644b9f",
    padding: "10px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "&:focus": {
      borderBottom: "5px solid #644b9f",
    },
    textAlign: "center",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontWeight: "bold",
  },
  flexColImg: {
    height: "40px",
    width: "40px",
    marginBottom: "10px",
  },
  flexCol: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  entered: {
    width: "100%",
  },
  translateBox: {
    padding: "10px",
  },
  language: {
    display: "flex",
    padding: "10px",
    marginBottom: "15px",
    alignItems: "center",
    "&:hover": {
      background: "#b499d7",
      cursor: "pointer",
    },
  },
  languageMain: {
    fontFamily: "Montserrat",
    fontSize: "18px",
    fontWeight: "bold",
    flex: 1,
  },
}));

function TranslatePopover(props) {
  const classes = useStyles();
  const { anchorEl, setAnchorEl } = props;
  const [collapse, setCollapse] = useState(false);
  const [translate, setTranslate] = useState(false);
  const {width} = useWindowDimensions()
  const small = width < 500;

  const changeLanguagePortal = (lang) => {
    localStorage.setItem("SelectedLang", lang);
    window.location.reload();
  };

  const handleClose = () => {};

  return (
    <Popover
      id={Boolean(anchorEl) ? "simple-popover" : undefined}
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      classes={{ root: classes.rootroot, paper: classes.root2 }}
    >
      <Box className={classes.header}>
        <Typography style={{ paddingLeft: "60px" }} className={classes.ty}>
          Translate
        </Typography>
        <IconButton
          onClick={() => {
            props.setTranslate(false);
          }}
          style={{
            position: "absolute",
            top: 25,
            left: 20,
            background: "rgba(255,255,255,0.2)",
            padding: 5,
          }}
        >
          <ArrowBackRoundedIcon style={{ color: "white" }} />
        </IconButton>
      </Box>
      <Box className={classes.translateBox}>
        <Paper
          elevation={4}
          className={classes.language}
          onClick={() => {
            if (localStorage.getItem("SelectedLang") === "en") {
            } else {
              changeLanguagePortal("en");
            }
          }}
        >
          <Typography className={classes.languageMain}>English</Typography>
          {localStorage.getItem("SelectedLang") === "en" && (
            <img
              src={greenSuccessIcon}
              style={{
                height: "20px",
                width: "20px",
                borderRadius: "50%",
              }}
            />
          )}
        </Paper>
        <Paper
          elevation={4}
          className={classes.language}
          onClick={() => {
            if (localStorage.getItem("SelectedLang") === "hi") {
            } else {
              changeLanguagePortal("hi");
            }
          }}
        >
          <Typography className={classes.languageMain}>Hindi</Typography>
          {localStorage.getItem("SelectedLang") === "hi" && (
            <img
              src={greenSuccessIcon}
              style={{
                height: "20px",
                width: "20px",
                borderRadius: "50%",
              }}
            />
          )}
        </Paper>
        {/* <Paper
          elevation={4}
          className={classes.language}
          onClick={() => {
            if (localStorage.getItem("SelectedLang") === "hi") {
            } else {
              changeLanguagePortal("hi");
            }
          }}
        >
          <Typography className={classes.languageMain}>Telugu</Typography>
          {localStorage.getItem("SelectedLang") === "hi" && (
            <img
              src={greenSuccessIcon}
              style={{
                height: "20px",
                width: "20px",
                borderRadius: "50%",
              }}
            />
          )}
        </Paper>
        <Paper
          elevation={4}
          className={classes.language}
          onClick={() => {
            if (localStorage.getItem("SelectedLang") === "hi") {
            } else {
              changeLanguagePortal("hi");
            }
          }}
        >
          <Typography className={classes.languageMain}>Bengali</Typography>
          {localStorage.getItem("SelectedLang") === "hi" && (
            <img
              src={greenSuccessIcon}
              style={{
                height: "20px",
                width: "20px",
                borderRadius: "50%",
              }}
            />
          )}
        </Paper>
        <Paper
          elevation={4}
          className={classes.language}
          onClick={() => {
            if (localStorage.getItem("SelectedLang") === "hi") {
            } else {
              changeLanguagePortal("hi");
            }
          }}
        >
          <Typography className={classes.languageMain}>Marathi</Typography>
          {localStorage.getItem("SelectedLang") === "hi" && (
            <img
              src={greenSuccessIcon}
              style={{
                height: "20px",
                width: "20px",
                borderRadius: "50%",
              }}
            />
          )}
        </Paper>
        <Paper
          elevation={4}
          className={classes.language}
          onClick={() => {
            if (localStorage.getItem("SelectedLang") === "hi") {
            } else {
              changeLanguagePortal("hi");
            }
          }}
        >
          <Typography className={classes.languageMain}>Oriya</Typography>
          {localStorage.getItem("SelectedLang") === "hi" && (
            <img
              src={greenSuccessIcon}
              style={{
                height: "20px",
                width: "20px",
                borderRadius: "50%",
              }}
            />
          )}
        </Paper>
        <Paper
          elevation={4}
          className={classes.language}
          onClick={() => {
            if (localStorage.getItem("SelectedLang") === "hi") {
            } else {
              changeLanguagePortal("hi");
            }
          }}
        >
          <Typography className={classes.languageMain}>Assamese</Typography>
          {localStorage.getItem("SelectedLang") === "hi" && (
            <img
              src={greenSuccessIcon}
              style={{
                height: "20px",
                width: "20px",
                borderRadius: "50%",
              }}
            />
          )}
        </Paper>
        <Paper
          elevation={4}
          className={classes.language}
          onClick={() => {
            if (localStorage.getItem("SelectedLang") === "hi") {
            } else {
              changeLanguagePortal("hi");
            }
          }}
        >
          <Typography className={classes.languageMain}>Malayalam</Typography>
          {localStorage.getItem("SelectedLang") === "hi" && (
            <img
              src={greenSuccessIcon}
              style={{
                height: "20px",
                width: "20px",
                borderRadius: "50%",
              }}
            />
          )}
        </Paper>
        <Paper
          elevation={4}
          className={classes.language}
          onClick={() => {
            if (localStorage.getItem("SelectedLang") === "hi") {
            } else {
              changeLanguagePortal("hi");
            }
          }}
        >
          <Typography className={classes.languageMain}>Tamil</Typography>
          {localStorage.getItem("SelectedLang") === "hi" && (
            <img
              src={greenSuccessIcon}
              style={{
                height: "20px",
                width: "20px",
                borderRadius: "50%",
              }}
            />
          )}
        </Paper>
        <Paper
          elevation={4}
          className={classes.language}
          onClick={() => {
            if (localStorage.getItem("SelectedLang") === "hi") {
            } else {
              changeLanguagePortal("hi");
            }
          }}
        >
          <Typography className={classes.languageMain}>Gujarati</Typography>
          {localStorage.getItem("SelectedLang") === "hi" && (
            <img
              src={greenSuccessIcon}
              style={{
                height: "20px",
                width: "20px",
                borderRadius: "50%",
              }}
            />
          )}
        </Paper>

         <Paper
          elevation={4}
          className={classes.language}
          onClick={() => {
            if (localStorage.getItem("SelectedLang") === "hi") {
            } else {
              changeLanguagePortal("hi");
            }
          }}
        >
          <Typography className={classes.languageMain}>Kannada</Typography>
          {localStorage.getItem("SelectedLang") === "hi" && (
            <img
              src={greenSuccessIcon}
              style={{
                height: "20px",
                width: "20px",
                borderRadius: "50%",
              }}
            />
          )}
        </Paper>
        <Paper
          elevation={4}
          className={classes.language}
          onClick={() => {
            if (localStorage.getItem("SelectedLang") === "hi") {
            } else {
              changeLanguagePortal("hi");
            }
          }}
        >
          <Typography className={classes.languageMain}>Punjabi</Typography>
          {localStorage.getItem("SelectedLang") === "hi" && (
            <img
              src={greenSuccessIcon}
              style={{
                height: "20px",
                width: "20px",
                borderRadius: "50%",
              }}
            />
          )}
        </Paper> */}
        
  
      </Box>
    </Popover>
  );
}

export default function SimplePopover(props) {
  const classes = useStyles();
  const { anchorEl, setAnchorEl } = props;
  const [dark, setDark] = useState(false);
  const [collapse, setCollapse] = useState(false);
  const [translate, setTranslate] = useState(false);

  if (props.dislexia) {
    import("./dislexia.css");
  }

  if (props.line) {
    import("./lineHeight.css");
  }
  if (dark) {
    import("./dark-mode.css");
  }
  if (props.wordS) {
    import("./wordS.css");
  }
  if (props.letterS) {
    import("./letterS.css");
  }
  if (props.fontS) {
    import("./fontS.css");
  }
  const handleClose = () => {
    setAnchorEl(null);
    setCollapse(false);
  };

  const changeLanguagePortal = (lang) => {
    localStorage.setItem("SelectedLang", lang);
    window.location.reload();
  };

  return translate ? (
    <TranslatePopover
      {...props}
      translate={translate}
      setTranslate={setTranslate}
    />
  ) : (
    <Popover
      id={Boolean(anchorEl) ? "simple-popover" : undefined}
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      classes={{ root: classes.rootroot, paper: classes.root }}
    >
      <Box className={classes.header}>
        <Typography className={classes.ty}>Help {"&"} Accessibility</Typography>
        <Typography className={classes.ty2}>
          MAARG Portal by Startup India
        </Typography>
        <IconButton
          onClick={() => {
            setAnchorEl(null);
            setCollapse(false);
          }}
          style={{
            position: "absolute",
            top: 20,
            right: 20,
            background: "rgba(255,255,255,0.2)",
            padding: 5,
          }}
        >
          <CloseRoundedIcon style={{ color: "white" }} />
        </IconButton>
      </Box>

      <Grid spacing={3} container>
        <Grid item xs={6}>
          <Card className={classes.card} elevation={4}>
            <CardActionArea
              onClick={() => {
                props.setCursor(!props.cursor);
                if (!props.cursor) {
                  props.setAnchorEl(null);
                }
              }}
              className={classes.cardActionArea}
            >
              {props.cursor && (
                <img
                  src={greenSuccessIcon}
                  style={{
                    position: "absolute",
                    top: 10,
                    right: 10,
                    height: "20px",
                    width: "20px",
                    borderRadius: "50%",
                  }}
                />
              )}
              <div className={classes.flexCol}>
                <svg
                  data-v-2c0ffeb7=""
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="mouse-pointer"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 320 512"
                  class="svg-inline--fa fa-mouse-pointer fa-w-10"
                  className={classes.flexColImg}
                >
                  <path
                    data-v-2c0ffeb7=""
                    fill="currentColor"
                    d="M302.189 329.126H196.105l55.831 135.993c3.889 9.428-.555 19.999-9.444 23.999l-49.165 21.427c-9.165 4-19.443-.571-23.332-9.714l-53.053-129.136-86.664 89.138C18.729 472.71 0 463.554 0 447.977V18.299C0 1.899 19.921-6.096 30.277 5.443l284.412 292.542c11.472 11.179 3.007 31.141-12.5 31.141z"
                    class=""
                  ></path>
                </svg>
                Big Cursor
              </div>
            </CardActionArea>
          </Card>
        </Grid>
        <Grid item xs={6}>
          <Card className={classes.card} elevation={4}>
            <CardActionArea
              onClick={() => {
                const something = props.dislexia;
                props.setDislexia(!props.dislexia);
                if (something) {
                  props.setAnchorEl(null);
                  window.location.reload(false);
                }
              }}
              className={classes.cardActionArea}
            >
              {props.dislexia && (
                <img
                  src={greenSuccessIcon}
                  style={{
                    position: "absolute",
                    top: 10,
                    right: 10,
                    height: "20px",
                    width: "20px",
                    borderRadius: "50%",
                  }}
                />
              )}
              <div className={classes.flexCol}>
                <svg
                  data-v-2c0ffeb7=""
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="book-reader"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                  class="svg-inline--fa fa-book-reader fa-w-16"
                  className={classes.flexColImg}
                >
                  <path
                    data-v-2c0ffeb7=""
                    fill="currentColor"
                    d="M352 96c0-53.02-42.98-96-96-96s-96 42.98-96 96 42.98 96 96 96 96-42.98 96-96zM233.59 241.1c-59.33-36.32-155.43-46.3-203.79-49.05C13.55 191.13 0 203.51 0 219.14v222.8c0 14.33 11.59 26.28 26.49 27.05 43.66 2.29 131.99 10.68 193.04 41.43 9.37 4.72 20.48-1.71 20.48-11.87V252.56c-.01-4.67-2.32-8.95-6.42-11.46zm248.61-49.05c-48.35 2.74-144.46 12.73-203.78 49.05-4.1 2.51-6.41 6.96-6.41 11.63v245.79c0 10.19 11.14 16.63 20.54 11.9 61.04-30.72 149.32-39.11 192.97-41.4 14.9-.78 26.49-12.73 26.49-27.06V219.14c-.01-15.63-13.56-28.01-29.81-27.09z"
                    class=""
                  ></path>
                </svg>
                Dyslexia
              </div>
            </CardActionArea>
          </Card>
        </Grid>
        <Grid item xs={6}>
          <Card
            className={classes.card}
            style={{ marginLeft: "3px", marginTop: "3px" }}
            elevation={4}
          >
            <CardActionArea
              onClick={() => {
                props.setFontS(!props.fontS);
                if (props.fontS) {
                  props.setAnchorEl(null);
                  window.location.reload(false);
                }
              }}
              className={classes.cardActionArea}
            >
              {props.fontS && (
                <img
                  src={greenSuccessIcon}
                  style={{
                    position: "absolute",
                    top: 10,
                    right: 10,
                    height: "20px",
                    width: "20px",
                    borderRadius: "50%",
                  }}
                />
              )}
              <div className={classes.flexCol}>
                <svg
                  data-v-2c0ffeb7=""
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="font"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                  class="svg-inline--fa fa-font fa-w-14"
                  className={classes.flexColImg}
                >
                  <path
                    data-v-2c0ffeb7=""
                    fill="currentColor"
                    d="M432 416h-23.41L277.88 53.69A32 32 0 0 0 247.58 32h-47.16a32 32 0 0 0-30.3 21.69L39.41 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-19.58l23.3-64h152.56l23.3 64H304a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM176.85 272L224 142.51 271.15 272z"
                    class=""
                  ></path>
                </svg>
                Large Font
              </div>
            </CardActionArea>
          </Card>
        </Grid>
        <Grid item xs={6}>
          <Card className={classes.card} elevation={4}>
            <CardActionArea
              onClick={() => {
                setDark(!dark);
                if (dark) {
                  props.setAnchorEl(null);
                  window.location.reload(false);
                }
              }}
              className={classes.cardActionArea}
            >
              {dark && (
                <img
                  src={greenSuccessIcon}
                  style={{
                    position: "absolute",
                    top: 10,
                    right: 10,
                    height: "20px",
                    width: "20px",
                    borderRadius: "50%",
                  }}
                />
              )}
              <div className={classes.flexCol}>
                <svg
                  data-v-2c0ffeb7=""
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="moon"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                  class="svg-inline--fa fa-moon fa-w-16"
                  className={classes.flexColImg}
                >
                  <path
                    data-v-2c0ffeb7=""
                    fill="currentColor"
                    d="M283.211 512c78.962 0 151.079-35.925 198.857-94.792 7.068-8.708-.639-21.43-11.562-19.35-124.203 23.654-238.262-71.576-238.262-196.954 0-72.222 38.662-138.635 101.498-174.394 9.686-5.512 7.25-20.197-3.756-22.23A258.156 258.156 0 0 0 283.211 0c-141.309 0-256 114.511-256 256 0 141.309 114.511 256 256 256z"
                    class=""
                  ></path>
                </svg>
                Dark Mode
              </div>
            </CardActionArea>
          </Card>
        </Grid>
        <Grid item xs={6}>
          <Card
            className={classes.card}
            style={{ marginLeft: "3px", marginTop: "3px" }}
            elevation={4}
          >
            <CardActionArea
              onClick={() => {
                setTranslate(true);
              }}
              className={classes.cardActionArea}
            >
              <div className={classes.flexCol}>
                <svg
                  data-v-2c0ffeb7=""
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="language"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 640 512"
                  class="svg-inline--fa fa-language fa-w-20"
                  className={classes.flexColImg}
                >
                  <path
                    data-v-2c0ffeb7=""
                    fill="currentColor"
                    d="M152.1 236.2c-3.5-12.1-7.8-33.2-7.8-33.2h-.5s-4.3 21.1-7.8 33.2l-11.1 37.5H163zM616 96H336v320h280c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24zm-24 120c0 6.6-5.4 12-12 12h-11.4c-6.9 23.6-21.7 47.4-42.7 69.9 8.4 6.4 17.1 12.5 26.1 18 5.5 3.4 7.3 10.5 4.1 16.2l-7.9 13.9c-3.4 5.9-10.9 7.8-16.7 4.3-12.6-7.8-24.5-16.1-35.4-24.9-10.9 8.7-22.7 17.1-35.4 24.9-5.8 3.5-13.3 1.6-16.7-4.3l-7.9-13.9c-3.2-5.6-1.4-12.8 4.2-16.2 9.3-5.7 18-11.7 26.1-18-7.9-8.4-14.9-17-21-25.7-4-5.7-2.2-13.6 3.7-17.1l6.5-3.9 7.3-4.3c5.4-3.2 12.4-1.7 16 3.4 5 7 10.8 14 17.4 20.9 13.5-14.2 23.8-28.9 30-43.2H412c-6.6 0-12-5.4-12-12v-16c0-6.6 5.4-12 12-12h64v-16c0-6.6 5.4-12 12-12h16c6.6 0 12 5.4 12 12v16h64c6.6 0 12 5.4 12 12zM0 120v272c0 13.3 10.7 24 24 24h280V96H24c-13.3 0-24 10.7-24 24zm58.9 216.1L116.4 167c1.7-4.9 6.2-8.1 11.4-8.1h32.5c5.1 0 9.7 3.3 11.4 8.1l57.5 169.1c2.6 7.8-3.1 15.9-11.4 15.9h-22.9a12 12 0 0 1-11.5-8.6l-9.4-31.9h-60.2l-9.1 31.8c-1.5 5.1-6.2 8.7-11.5 8.7H70.3c-8.2 0-14-8.1-11.4-15.9z"
                    class=""
                  ></path>
                </svg>
                Translate
              </div>
            </CardActionArea>
          </Card>
        </Grid>

        <Grid item xs={6}>
          <Card
            className={classes.card}
            style={{ marginLeft: "3px", marginTop: "3px" }}
            elevation={4}
          >
            <CardActionArea
              onClick={() => {
                // props.setLetterS(!props.letterS);
                // if (props.letterS) {
                //   props.setAnchorEl(null);
                //   window.location.reload(false);
                // }
              }}
              className={classes.cardActionArea}
            >
              {/* {props.letterS && (
                <img
                  src={greenSuccessIcon}
                  style={{
                    position: "absolute",
                    top: 10,
                    right: 10,
                    height: "20px",
                    width: "20px",
                    borderRadius: "50%",
                  }}
                />
              )} */}
              <div className={classes.flexCol}>
                <svg
                  data-v-2c0ffeb7=""
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="keyboard"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 576 512"
                  class="svg-inline--fa fa-keyboard fa-w-18"
                  className={classes.flexColImg}
                >
                  <path
                    data-v-2c0ffeb7=""
                    fill="currentColor"
                    d="M528 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM128 180v-40c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm288 0v-40c0-6.627-5.373-12-12-12H172c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h232c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12z"
                    class=""
                  ></path>
                </svg>
                Keyboard Nav
              </div>
            </CardActionArea>
          </Card>
        </Grid>
        <Grid item xs={12} container>
          <Collapse
            in={collapse}
            classes={{
              entered: classes.entered,
            }}
          >
            <Grid container spacing={3}>
              <Grid item xs={6}>
                <Card
                  className={classes.card}
                  style={{ marginLeft: "3px", marginTop: "3px" }}
                  elevation={4}
                >
                  <CardActionArea
                    onClick={() => {
                      props.setLetterS(!props.letterS);
                      if (props.letterS) {
                        props.setAnchorEl(null);
                        window.location.reload(false);
                      }
                    }}
                    className={classes.cardActionArea}
                  >
                    {props.letterS && (
                      <img
                        src={greenSuccessIcon}
                        style={{
                          position: "absolute",
                          top: 10,
                          right: 10,
                          height: "20px",
                          width: "20px",
                          borderRadius: "50%",
                        }}
                      />
                    )}
                    <div className={classes.flexCol}>
                      <svg
                        data-v-2c0ffeb7=""
                        aria-hidden="true"
                        focusable="false"
                        data-prefix="fas"
                        data-icon="text-width"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 448 512"
                        class="svg-inline--fa fa-text-width fa-w-14"
                        className={classes.flexColImg}
                      >
                        <path
                          data-v-2c0ffeb7=""
                          fill="currentColor"
                          d="M432 32H16A16 16 0 0 0 0 48v80a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-16h120v112h-24a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-24V112h120v16a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm-68.69 260.69C354 283.36 336 288.36 336 304v48H112v-48c0-14.31-17.31-21.32-27.31-11.31l-80 80a16 16 0 0 0 0 22.62l80 80C94 484.64 112 479.64 112 464v-48h224v48c0 14.31 17.31 21.33 27.31 11.31l80-80a16 16 0 0 0 0-22.62z"
                          class=""
                        ></path>
                      </svg>
                      Increase Letter Spacing
                    </div>
                  </CardActionArea>
                </Card>
              </Grid>
              <Grid item xs={6}>
                <Card className={classes.card} elevation={4}>
                  <CardActionArea
                    onClick={() => {
                      props.setWordS(!props.wordS);
                      if (props.wordS) {
                        props.setAnchorEl(null);
                        window.location.reload(false);
                      }
                    }}
                    className={classes.cardActionArea}
                  >
                    {props.wordS && (
                      <img
                        src={greenSuccessIcon}
                        style={{
                          position: "absolute",
                          top: 10,
                          right: 10,
                          height: "20px",
                          width: "20px",
                          borderRadius: "50%",
                        }}
                      />
                    )}
                    <div className={classes.flexCol}>
                      <svg
                        data-v-2c0ffeb7=""
                        aria-hidden="true"
                        focusable="false"
                        data-prefix="fas"
                        data-icon="align-justify"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 448 512"
                        class="svg-inline--fa fa-align-justify fa-w-14"
                        className={classes.flexColImg}
                      >
                        <path
                          data-v-2c0ffeb7=""
                          fill="currentColor"
                          d="M432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                          class=""
                        ></path>
                      </svg>
                      Increase Word Spacing
                    </div>
                  </CardActionArea>
                </Card>
              </Grid>
              <Grid item xs={6}>
                <Card className={classes.card} elevation={4}>
                  <CardActionArea
                    onClick={() => {
                      const something = props.line;
                      props.setLine(!props.line);
                      if (something) {
                        props.setAnchorEl(null);
                        window.location.reload(false);
                      }
                    }}
                    className={classes.cardActionArea}
                  >
                    {props.line && (
                      <img
                        src={greenSuccessIcon}
                        style={{
                          position: "absolute",
                          top: 10,
                          right: 10,
                          height: "20px",
                          width: "20px",
                          borderRadius: "50%",
                        }}
                      />
                    )}
                    <div className={classes.flexCol}>
                      <svg
                        data-v-2c0ffeb7=""
                        aria-hidden="true"
                        focusable="false"
                        data-prefix="fas"
                        data-icon="text-height"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 576 512"
                        class="svg-inline--fa fa-text-height fa-w-18"
                        className={classes.flexColImg}
                      >
                        <path
                          data-v-2c0ffeb7=""
                          fill="currentColor"
                          d="M304 32H16A16 16 0 0 0 0 48v96a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32h56v304H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h160a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-40V112h56v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm256 336h-48V144h48c14.31 0 21.33-17.31 11.31-27.31l-80-80a16 16 0 0 0-22.62 0l-80 80C379.36 126 384.36 144 400 144h48v224h-48c-14.31 0-21.32 17.31-11.31 27.31l80 80a16 16 0 0 0 22.62 0l80-80C580.64 386 575.64 368 560 368z"
                          class=""
                        ></path>
                      </svg>
                      Increase Line Height
                    </div>
                  </CardActionArea>
                </Card>
              </Grid>
            </Grid>
          </Collapse>
        </Grid>
      </Grid>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "14px",
          fontWeight: "bold",
          marginTop: "10px",
        }}
      >
        <div
          onClick={() => setCollapse(!collapse)}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
          }}
        >
          <ExpandMoreRoundedIcon
            style={collapse ? { transform: "rotate(180deg)" } : {}}
          />
          More Help and Accesibility
        </div>
      </div>
    </Popover>
  );
}
